import { render, staticRenderFns } from "./GuestsBoardAnalytics.vue?vue&type=template&id=3bce2a7c&scoped=true"
import script from "./GuestsBoardAnalytics.vue?vue&type=script&lang=js"
export * from "./GuestsBoardAnalytics.vue?vue&type=script&lang=js"
import style0 from "./GuestsBoardAnalytics.vue?vue&type=style&index=0&id=3bce2a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bce2a7c",
  null
  
)

export default component.exports